import apiClient from '../api/client';
export const fetchAPI = async (endpoint, hostType, params, headers) => {
    const opts = {
        headers,
    };
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        value !== undefined && query.append(key, value);
    });
    const url = `${endpoint}${params !== undefined && Object.keys(params).length > 0 ? `?${query.toString()}` : ''}`;
    return apiClient.get(url, hostType, opts);
};
